import {
    getEmployeeContains,
    getEmployeesOptionsPaginated,
} from '@/modules/Employee/services'
import { AsyncFilterSelect } from '@/components/ui/filters/async-filter-select'
import { FieldValues, Path, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface EmployeeSelectProps<T extends FieldValues> {
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    multiple?: boolean
    showLabel?: boolean
    disabled?: boolean
    label?: string
    placeholder?: string
    excludeEmployeeIds?: number[]
    /** Department IDs to filter employees by */
    departmentIds?: number[]
    onlyActive?: boolean
}

const EmployeeSelect = <T extends FieldValues>({
    control,
    name,
    multiple,
    label,
    placeholder,
    showLabel = true,
    disabled = false,
    excludeEmployeeIds = [],
    departmentIds = [],
    onlyActive = false,
}: EmployeeSelectProps<T>) => {
    const { t } = useTranslation()

    const asyncOptions = async (query: string, page: number = 1) => {
        const result = await getEmployeesOptionsPaginated(
            query,
            departmentIds,
            onlyActive ? 'active' : undefined,
            page
        )
        if (!excludeEmployeeIds?.length) return result
        return {
            ...result,
            options: result.options.filter(
                (opt) => !excludeEmployeeIds.includes(opt.value as number)
            ),
        }
    }

    return (
        <AsyncFilterSelect<T>
            label={showLabel ? t(label ?? 'employee-followers') : undefined}
            placeholder={placeholder ?? t(label ?? 'employee-followers')}
            control={control}
            name={name}
            asyncOptions={asyncOptions}
            multiple={multiple}
            getDefaultOptions={(value) =>
                getEmployeeContains({ employee_ids: value })
            }
            disabled={disabled}
            showClearButton={false}
        />
    )
}

export default EmployeeSelect
